import React, { memo } from 'react';

import { Icon } from "../ui/Icon";

import styles from './Loader.module.css';

const Loader: React.FC = memo(() => <Icon name={'loader'} className={styles.loader} data-testid="loader" />);

Loader.displayName = 'Loader';

export default Loader;
